import styled from "styled-components"
import { FormItem } from "../.."

const StyledFormItem = styled(FormItem)`
  .ant {
    &-form-item-extra {
      margin-left: initial;
      transform: initial;
    }
    &-select-selection-search {
      left: initial;
      right: initial;
      position: initial;
      width: 110px !important;
      &-input {
        height: 28px;
      }
      &-mirror {
        display: none;
      }
    }
  }
`

export const Styled = {
  StyledFormItem,
}
